// @flow
import styled from 'styled-components';
import { below } from '../../assets/css/media';

export const PlayerRowMenuStyled = styled.div`
	position: absolute;
	top: 2px;
	right: 2px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: 56px;
	min-width: 340px;
	background: #fff;
	box-shadow: ${({ is_shadow }) => is_shadow ? '0 0 2px 0 rgba(0,0,0,0.15)' : 'none'};

	${below.desktop`
		height: 50px;
	`}
`;

export default PlayerRowMenuStyled;


// WEBPACK FOOTER //
// ./src/components/PlayerRowMenuStyled/index.js